export default function ConfirmModal({ isOpen, onClose, item, onConfirm }) {
  if (!isOpen || !item) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-[480px]">
        <h3 className="text-lg font-bold text-slate-800 mb-3">Êtes-vous sûr ?</h3>
        <p className="text-sm text-slate-500 mb-6">
          Cette action annulera l'abonnement du projet "{item.projet}". Les services associés à cet abonnement ne seront plus accessibles.
        </p>
        <div className="flex justify-end gap-3">
          <button onClick={onClose}
            className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm text-slate-600 hover:bg-gray-50">
            Annuler
          </button>
          <button onClick={onConfirm}
            className="px-5 py-2.5 bg-red-600 text-white rounded-xl text-sm font-semibold hover:bg-red-700">
            Annuler l'abonnement
          </button>
        </div>
      </div>
    </div>
  );
}